import { render, staticRenderFns } from "./Bes.vue?vue&type=template&id=6f8b25ef&scoped=true&"
import script from "./Bes.vue?vue&type=script&lang=js&"
export * from "./Bes.vue?vue&type=script&lang=js&"
import style0 from "./Bes.vue?vue&type=style&index=0&id=6f8b25ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b25ef",
  null
  
)

export default component.exports